import { Outlet } from 'react-router';
import PageTitleHandler from './PageTitleHandler';

const RoutesWrapper = () => {
  return (
    <>
      <PageTitleHandler />
      {/* TODO is GA needed? <GoogleAnalyticsHandler />*/}
      <Outlet />
    </>
  );
};

export default RoutesWrapper;
